/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { membershipWithResourceAndSchemesResponseSchema } from './membershipWithResourceAndSchemesResponseSchema';
import { teamSchema } from './teamSchema';

export const teamResponseSchema = z.object({
  get memberships() {
    return z.array(membershipWithResourceAndSchemesResponseSchema).nullish();
  },
  get team() {
    return teamSchema;
  },
});
